import _ from 'lodash';

export const camelCaseKeys = (obj) =>
  _.mapKeys(obj, (val, key) => _.camelCase(key));
